import { useSyncExternalStore } from 'react';
import { authService } from '../services/auth';
import { subscribeCreditRefresh } from '../services/creditRefresh';
import { createCreditAccountStore } from '../services/creditAccountStore';

/** 复用稳定登录周期，正常续期不清空账户快照，换号仍立即失效。 */
const accountStore = createCreditAccountStore({
  identity: () => authService.getSessionIdentity(),
  read: () => authService.credits.self(),
  onIdentityChange: listener => authService.subscribe(listener),
  onRefresh: listener => {
    /** 仅在页面可见时响应焦点事件；付款和轮次通知无须额外轮询。 */
    const onFocus = () => { if (document.visibilityState === 'visible') listener(); };
    const unsubscribe = subscribeCreditRefresh(listener);
    window.addEventListener('focus', onFocus);
    return () => { unsubscribe(); window.removeEventListener('focus', onFocus); };
  },
});

/** 账户页与侧栏读取同一权威快照；刷新不触发模型、充值或其他写操作。 */
export function useCreditAccount() {
  const snapshot = useSyncExternalStore(accountStore.subscribe, accountStore.getSnapshot);
  return { ...snapshot, refresh: accountStore.refresh };
}
